import React from 'react'

const SendNotificationAction = () => (
  <p>
    The auto close notice email will be sent to ticket primary contact
  </p>
)

export default SendNotificationAction
